/**
 * BYVIDA Subscription Widget V5, stacked variants
 * File: assets/byvida-subscription-widget-v5.js
 *
 * Same information as V4, laid out vertically: one full-width row per
 * variant (6M, 3M, 1M by default). The selected row opens to show the
 * Happy Hair Club Abo details and USPs. The proof line sits directly above
 * the CTA, and the (?) modal gains a "results after 3 months" section.
 *
 * Recharge SDK integration, selling plan map and cart logic are unchanged
 * from V4. Namespaced bsw-v5- so it can run side by side with V3 and V4.
 */

(function () {
  'use strict';

  var WIDGET_ID = 'byvida-sub-widget-v5';
  var MODAL_ID  = 'bsw-v5-modal';

  /* ------------------------------------------------------------------
     VARIANT CONFIG
     Badge labels come from the theme customizer; these are fallbacks.
  ------------------------------------------------------------------ */
  var VARIANT_DISPLAY = [
    { match: /6.?mon/i, id: '6m', label: '6 Monate', months: 6, badge: 'Top Preis', discountBadge: true },
    { match: /3.?mon/i, id: '3m', label: '3 Monate', months: 3, badge: 'Beliebt',   discountBadge: true },
    { match: /1.?mon/i, id: '1m', label: '1 Monat',  months: 1, badge: null,        discountBadge: false }
  ];

  var DEFAULT_USPS = [
    'Kostenloser Versand',
    'Bester Preis dank Abo-Rabatt',
    'Jederzeit kündbar, ohne Zusatzkosten'
  ];

  var DEFAULT_MODAL = {
    title: 'Deine Vorteile im Happy Hair Club Abo',
    usps: [
      {
        title: 'Kostenloser Versand',
        body: 'Als Abonnentin entfällt die Versandgebühr bei jeder Lieferung, automatisch und ohne Mindestbestellwert.',
        icon: '<path d="M4 14h22v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V14Z" stroke="#0424E6" stroke-width="1.75" stroke-linejoin="round"/><path d="M26 18h5.382a2 2 0 0 1 1.789 1.106l2.618 5.235A2 2 0 0 1 36 25.236V30a2 2 0 0 1-2 2h-2" stroke="#0424E6" stroke-width="1.75" stroke-linejoin="round"/><circle cx="11" cy="33" r="3" stroke="#0424E6" stroke-width="1.75"/><circle cx="30" cy="33" r="3" stroke="#0424E6" stroke-width="1.75"/><path d="M4 20h22M14 32h12" stroke="#0424E6" stroke-width="1.75" stroke-linecap="round"/><path d="M8 14V9a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5" stroke="#0424E6" stroke-width="1.75" stroke-linecap="round"/>'
      },
      {
        title: 'Bester Preis dank Abo-Rabatt',
        body: 'Im Abo sparst du gegenüber dem Einzelkauf. Der Rabatt wird automatisch abgezogen, bei jeder Bestellung.',
        icon: '<path d="M20 4L4 12v8c0 8.837 6.863 17.13 16 19 9.137-1.87 16-10.163 16-19v-8L20 4Z" stroke="#0424E6" stroke-width="1.75" stroke-linejoin="round"/><path d="M14 21l4 4 8-8" stroke="#0424E6" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>'
      },
      {
        title: 'Jederzeit kündbar',
        body: 'Keine Mindestlaufzeit, keine versteckten Bedingungen. Pausieren oder kündigen geht jederzeit direkt in deinem Kundenkonto.',
        icon: '<circle cx="20" cy="20" r="16" stroke="#0424E6" stroke-width="1.75"/><path d="M20 11v9l6 4" stroke="#0424E6" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 32c2.5-2 6-3 12-3s9.5 1 12 3" stroke="#0424E6" stroke-width="1.75" stroke-linecap="round"/>'
      }
    ]
  };

  /* ------------------------------------------------------------------
     READ CONFIG (theme customizer settings via data attributes)
  ------------------------------------------------------------------ */
  function readConfig(container) {
    var ds = container.dataset;
    var order = (ds.variantOrder || '6m,3m,1m').split(',').map(function (s) { return s.trim(); });

    var variantImages = {};
    try {
      variantImages = JSON.parse(ds.variantImages || '{}');
    } catch (e) { /* ignore */ }

    return {
      defaultPlan:    ds.defaultPlan   || '6m',
      variantOrder:   order,
      variantImages:  variantImages,
      sizeLabel:      ds.sizeLabel     || 'Wähle deine Verpackungsgröße',
      savingsFormat:  ds.savingsFormat || 'percent',
      showPerDay:     ds.showPerDay !== 'false',
      showCardSavings: ds.showCardSavings !== 'false',
      perDayDays:     parseInt(ds.perDayDays, 10) || 28,

      badges: {
        '6m': typeof ds.badge6m === 'string' ? ds.badge6m : 'Top Preis',
        '3m': typeof ds.badge3m === 'string' ? ds.badge3m : 'Beliebt',
        '1m': typeof ds.badge1m === 'string' ? ds.badge1m : ''
      },

      aboLabel:        ds.aboLabel        || 'Happy Hair Club Abo',
      frequencyPrefix: ds.frequencyPrefix || 'Lieferung jeden',
      uspIcon:         typeof ds.uspIcon === 'string' ? ds.uspIcon : '💙',

      ctaText:         ds.ctaText         || 'JETZT KAUFEN',
      ctaOnetimeText:  ds.ctaOnetimeText  || 'EINMAL KAUFEN',
      ctaShowPrice:    ds.ctaShowPrice === 'true',
      addingText:      ds.addingText      || 'WIRD HINZUGEFÜGT…',
      addedText:       ds.addedText       || 'HINZUGEFÜGT ✓',
      errorText:       ds.errorText       || 'FEHLER – ERNEUT VERSUCHEN',
      sticky:          ds.sticky !== 'false',

      /* Two independent ways to kill the proof line, because an A/B test
         must not depend on a text field being exactly empty:
           1. showProof = false  (the explicit toggle, wins over any text)
           2. proofText trims to '' (blank or whitespace-only field)
         No fallback text here on purpose. If the attribute is missing
         entirely (older snippet still on the theme) showProof stays true
         and the text alone decides, which is the old behaviour. */
      /* Trust checkmarks above the CTA. Read with getAttribute: dataset
         would turn data-trust-1 into dataset['trust-1'], not trust1.
         A blank field hides its line. */
      showTrust:       container.getAttribute('data-show-trust') !== 'false',
      trust:           [1, 2, 3].map(function (n) {
        var v = container.getAttribute('data-trust-' + n);
        return typeof v === 'string' ? v.trim()
          : ['12 Wochen Geld-zurück-Garantie', 'Lieferzeit 2-4 Werktage', 'Versandkostenfrei im Abo in DE & AT'][n - 1];
      }),

      showProof:       ds.showProof !== 'false',
      proofText:       (ds.proofText || '').trim(),

      showOnetime:     ds.showOnetime !== 'false',
      onetimeLabel:    ds.onetimeLabel    || 'Einmalkauf',
      backToSubLabel:  ds.backToSubLabel  || 'Zum Abo wechseln',

      variantUsps: {
        '6m': [ds.usp6m1 || DEFAULT_USPS[0], ds.usp6m2 || DEFAULT_USPS[1], ds.usp6m3 || DEFAULT_USPS[2]],
        '3m': [ds.usp3m1 || DEFAULT_USPS[0], ds.usp3m2 || DEFAULT_USPS[1], ds.usp3m3 || DEFAULT_USPS[2]],
        '1m': [ds.usp1m1 || DEFAULT_USPS[0], ds.usp1m2 || 'Nur 2 Mindestlieferungen', ds.usp1m3 || 'Danach jederzeit kündbar, ohne Zusatzkosten']
      },

      modal: {
        title: ds.modalTitle || DEFAULT_MODAL.title,
        dismiss: ds.modalDismiss || 'Alles klar',
        usps: [
          {
            title: ds.modalUsp1Title || DEFAULT_MODAL.usps[0].title,
            body:  ds.modalUsp1Body  || DEFAULT_MODAL.usps[0].body,
            icon:  DEFAULT_MODAL.usps[0].icon
          },
          {
            title: ds.modalUsp2Title || DEFAULT_MODAL.usps[1].title,
            body:  ds.modalUsp2Body  || DEFAULT_MODAL.usps[1].body,
            icon:  DEFAULT_MODAL.usps[1].icon
          },
          {
            title: ds.modalUsp3Title || DEFAULT_MODAL.usps[2].title,
            body:  ds.modalUsp3Body  || DEFAULT_MODAL.usps[2].body,
            icon:  DEFAULT_MODAL.usps[2].icon
          }
        ],
        results: {
          show:      ds.showModalResults !== 'false',
          title:     ds.modalResultsTitle     || 'Die besten Ergebnisse nach 3 Monaten',
          intro:     ds.modalResultsIntro     || '',
          stat1:     ds.modalResultsStat1     || '',
          stat1Text: ds.modalResultsStat1Text || '',
          stat2:     ds.modalResultsStat2     || '',
          stat2Text: ds.modalResultsStat2Text || ''
        },
        usp3_1m: {
          title: ds.modalUsp3Title1m || 'Nur 2 Mindestlieferungen',
          body:  ds.modalUsp3Body1m  || 'Beim 1-Monats-Abo sind nur 2 Lieferungen Minimum. Danach kannst du jederzeit pausieren oder kündigen, direkt in deinem Kundenkonto.'
        }
      }
    };
  }

  /* ------------------------------------------------------------------
     UTILITIES
  ------------------------------------------------------------------ */
  function toCents(val) {
    if (val == null) return 0;
    if (typeof val === 'string' && val.indexOf('.') > -1) {
      return Math.round(parseFloat(val) * 100);
    }
    return parseInt(val, 10) || 0;
  }

  function formatEur(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function formatEurRounded(cents) {
    return Math.round(cents / 100) + ' €';
  }

  function calcPerDay(cents, months, daysPerMonth) {
    var days = months * (daysPerMonth || 28);
    return (cents / 100 / days).toFixed(2).replace('.', ',') + ' €/Tag';
  }

  function matchDisplay(title) {
    if (!title) return null;
    for (var i = 0; i < VARIANT_DISPLAY.length; i++) {
      if (VARIANT_DISPLAY[i].match.test(title)) return VARIANT_DISPLAY[i];
    }
    return null;
  }

  /* Keeps number+unit pairs on one line, so a wrap never splits
     "12 Wochen" or "91 %" across two lines. Also swaps the hyphens in
     compounds that start with a number ("3-Monats-Abo") for non-breaking
     ones, so the word is never cut at a hyphen. */
  function nbspUnits(str) {
    return String(str)
      .replace(/(\d)\s+(%|Wochen|Woche|Monate|Monaten|Monat|Tage|Tagen|Tag|Jahre|Jahren|Jahr)\b/g, '$1\u00a0$2')
      .replace(/\b\d+(?:-[A-Za-z\u00c4\u00d6\u00dc\u00e4\u00f6\u00fc\u00df]+)+/g, function (m) { return m.replace(/-/g, '\u2011'); });
  }

  function escHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function waitForRecharge(maxMs) {
    maxMs = maxMs || 6000;
    return new Promise(function (resolve, reject) {
      if (window.recharge && window.recharge.cdn) { resolve(window.recharge); return; }
      var start = Date.now();
      var timer = setInterval(function () {
        if (window.recharge && window.recharge.cdn) {
          clearInterval(timer);
          resolve(window.recharge);
        } else if (Date.now() - start > maxMs) {
          clearInterval(timer);
          reject(new Error('[BYVIDA Widget V5] Recharge SDK not found after ' + maxMs + 'ms'));
        }
      }, 100);
    });
  }

  /* ------------------------------------------------------------------
     INIT
  ------------------------------------------------------------------ */
  function initWidget() {
    var container = document.getElementById(WIDGET_ID);
    if (!container) return;

    var productId = container.dataset.productId;
    if (!productId) return;

    var config = readConfig(container);

    var sellingPlanMap = {};
    try {
      sellingPlanMap = JSON.parse(container.dataset.sellingPlans || '{}');
    } catch (e) {
      console.warn('[BYVIDA Widget V5] Could not parse data-selling-plans:', e);
    }

    waitForRecharge()
      .then(function (rc) {
        if (!rc.cdn || typeof rc.cdn.getCDNProductAndSettings !== 'function') {
          throw new Error('getCDNProductAndSettings is not a function');
        }
        return rc.cdn.getCDNProductAndSettings(productId);
      })
      .then(function (data) {
        buildWidget(container, data, config, sellingPlanMap);
      })
      .catch(function (err) {
        console.error('[BYVIDA Widget V5] ERROR:', err.message || err);
        container.innerHTML = '<p style="color:red;font-size:13px;padding:12px;">[BYVIDA Widget V5] ' + escHtml(err.message || err) + '</p>';
      });
  }

  /* ------------------------------------------------------------------
     BUILD WIDGET
  ------------------------------------------------------------------ */
  function buildWidget(container, data, config, sellingPlanMap) {
    var product  = data.product || data;
    var variants = product.variants || [];

    var plans = [];
    variants.forEach(function (v) {
      var allocs = v.selling_plan_allocations || [];
      var variantTitle = v.title
        || (v.option_values && v.option_values.map(function (o) { return o.label; }).join(' / '))
        || '';
      var prices = v.prices || {};
      if (!allocs.length) return;

      var display = matchDisplay(variantTitle);
      if (!display) return;

      var variantId = v.external_variant_id || v.id;
      var shopifySellingPlanId = sellingPlanMap[String(variantId)];
      var alloc;
      if (shopifySellingPlanId) {
        alloc = allocs.find(function (a) { return String(a.selling_plan_id) === String(shopifySellingPlanId); }) || allocs[0];
      } else {
        alloc = allocs[0];
      }

      var subPriceCents     = toCents(alloc.discounted_price || alloc.price);
      var regularPriceCents = toCents(prices.unit_price || v.price || alloc.compare_at_price);
      var comparePriceCents = toCents(prices.compare_at_price || v.compare_at_price || alloc.compare_at_price) || regularPriceCents;

      var discount = comparePriceCents > subPriceCents
        ? Math.round((comparePriceCents - subPriceCents) / comparePriceCents * 100)
        : null;
      var discountEur = comparePriceCents > subPriceCents
        ? Math.round((comparePriceCents - subPriceCents) / 100)
        : null;

      /* Same figures for the Einmalkauf view, measured against the regular
         variant price. Where compare and regular price are equal (1 Monat)
         there is nothing to strike through and no savings. */
      var onetimeDiscount = comparePriceCents > regularPriceCents
        ? Math.round((comparePriceCents - regularPriceCents) / comparePriceCents * 100)
        : null;
      var onetimeDiscountEur = comparePriceCents > regularPriceCents
        ? Math.round((comparePriceCents - regularPriceCents) / 100)
        : null;

      var badge = config.badges[display.id];
      if (badge === undefined || badge === null) badge = display.badge;

      plans.push({
        id:                 display.id,
        label:              display.label,
        months:             display.months,
        badge:              badge || null,
        discountBadge:      display.discountBadge,
        variantId:          variantId,
        sellingPlanId:      shopifySellingPlanId || alloc.selling_plan_id,
        subPriceCents:      subPriceCents,
        regularPriceCents:  regularPriceCents,
        comparePriceCents:  comparePriceCents,
        discount:           discount,
        discountEur:        discountEur,
        perDay:             calcPerDay(subPriceCents, display.months, config.perDayDays),
        onetimeDiscount:    onetimeDiscount,
        onetimeDiscountEur: onetimeDiscountEur,
        onetimePerDay:      calcPerDay(regularPriceCents, display.months, config.perDayDays),
        imageUrl:           config.variantImages[String(variantId)] || null,
        usps:               (config.variantUsps[display.id] || config.variantUsps['6m']).slice(0)
      });
    });

    plans.sort(function (a, b) {
      var ai = config.variantOrder.indexOf(a.id);
      var bi = config.variantOrder.indexOf(b.id);
      if (ai === -1) ai = 99;
      if (bi === -1) bi = 99;
      return ai - bi;
    });

    if (!plans.length) {
      container.innerHTML = '<p style="color:red;font-size:13px;padding:12px;">[BYVIDA Widget V5] 0 plans matched.</p>';
      return;
    }

    var defaultId = config.defaultPlan;
    if (!plans.some(function (p) { return p.id === defaultId; })) defaultId = plans[0].id;

    var state = {
      selectedId: defaultId,
      oneTime:    false
    };

    function selectedPlan() {
      return plans.find(function (p) { return p.id === state.selectedId; }) || plans[0];
    }

    /* --- Cart logic --- */
    function addToCart() {
      var plan = selectedPlan();
      if (!plan) return;

      var payload = { quantity: 1, id: plan.variantId };
      if (!state.oneTime && plan.sellingPlanId) {
        payload.selling_plan = plan.sellingPlanId;
      }

      var btn = container.querySelector('.bsw-v5-cta');
      if (btn) { btn.disabled = true; btn.textContent = config.addingText; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [payload] })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (errBody) {
              throw new Error('Cart error ' + res.status + ': ' + (errBody.description || errBody.message || JSON.stringify(errBody)));
            });
          }
          return res.json();
        })
        .then(function () {
          if (btn) { btn.textContent = config.addedText; btn.disabled = false; }
          refreshCartDrawer();
          setTimeout(function () { render(); }, 1800);
        })
        .catch(function (err) {
          console.error('[BYVIDA Widget V5] Cart error:', err);
          if (btn) {
            btn.textContent = config.errorText;
            btn.disabled = false;
            setTimeout(function () { render(); }, 2500);
          }
        });
    }

    function refreshCartDrawer() {
      var drawerEl = document.querySelector('[id*="cart-drawer"][id^="shopify-section-"]');
      if (!drawerEl) return;
      var sectionId = drawerEl.id.replace('shopify-section-', '');

      fetch('/?sections=' + sectionId)
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          var html = sections[sectionId];
          if (html) drawerEl.innerHTML = html;

          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            });

          setTimeout(function () {
            var cartLink = document.querySelector('a[href="/cart"]') || document.querySelector('.navlink--cart');
            if (cartLink) cartLink.click();
          }, 100);
        })
        .catch(function (err) {
          console.warn('[BYVIDA Widget V5] Drawer refresh failed:', err);
        });
    }

    /* --- Render --- */
    function render() {
      container.innerHTML = buildHTML(plans, state, config);
      bindEvents();
    }

    function bindEvents() {
      container.querySelectorAll('.bsw-v5-row').forEach(function (card) {
        card.addEventListener('click', function () {
          state.selectedId = card.dataset.variantId;
          render();
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            state.selectedId = card.dataset.variantId;
            render();
          }
        });
      });

      var ctaBtn = container.querySelector('.bsw-v5-cta');
      if (ctaBtn) ctaBtn.addEventListener('click', addToCart);

      var onetimeBtn = container.querySelector('.bsw-v5-onetime-link');
      if (onetimeBtn) onetimeBtn.addEventListener('click', function () {
        state.oneTime = !state.oneTime;
        render();
      });

      var infoBtn = container.querySelector('.bsw-v5-info-btn');
      if (infoBtn) infoBtn.addEventListener('click', function (e) {
        /* The button sits inside the selected row; without this the row's
           own click handler re-renders the widget under the open modal. */
        e.stopPropagation();
        updateModalContent(config, state);
        openModal();
      });
    }

    setupModal(config);
    render();
    setupSticky(container, config);
  }

  /* ------------------------------------------------------------------
     STICKY BUTTON
     Appears once the widget CTA has scrolled up out of view: on desktop
     as a button in the header bar, on mobile as a bar under the header.
     A click forwards to the widget CTA, so the selected plan, Abo or
     Einmalkauf, goes into the cart exactly as from the widget itself.

     The CTA is looked up on every check, because render() rebuilds the
     widget and replaces the button. Scroll listener on purpose, not
     IntersectionObserver (see MENO-LP-HANDOVER.md, Fallen).
  ------------------------------------------------------------------ */
  var STICKY_BAR_ID    = 'bsw-v5-sticky-bar';
  var STICKY_HEADER_ID = 'bsw-v5-header-cta';
  var stickyCheck      = null;
  var stickyObserver   = null;

  function setupSticky(container, config) {
    /* Section reload in the theme editor: drop the old instance first */
    [STICKY_BAR_ID, STICKY_HEADER_ID].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.parentNode.removeChild(el);
    });
    if (stickyCheck) {
      window.removeEventListener('scroll', stickyCheck);
      window.removeEventListener('resize', stickyCheck);
      stickyCheck = null;
    }
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    if (!config.sticky) return;

    var bar = document.createElement('div');
    bar.id = STICKY_BAR_ID;
    bar.innerHTML = '<button type="button" class="bsw-v5-sticky-btn"></button>';
    document.body.appendChild(bar);
    var barBtn = bar.firstChild;

    var headerBtn = null;
    var headerSlot = document.querySelector('.header__desktop__bar__r');
    if (headerSlot) {
      headerBtn = document.createElement('button');
      headerBtn.type = 'button';
      headerBtn.id = STICKY_HEADER_ID;
      headerBtn.className = 'bsw-v5-sticky-btn';
      headerSlot.insertBefore(headerBtn, headerSlot.firstChild);
    }

    function trigger() {
      var cta = container.querySelector('.bsw-v5-cta');
      if (cta && !cta.disabled) cta.click();
    }
    barBtn.addEventListener('click', trigger);
    if (headerBtn) headerBtn.addEventListener('click', trigger);

    function isMobile() {
      var m = document.querySelector('.header__mobile');
      return !!(m && m.offsetParent !== null);
    }

    stickyCheck = function () {
      var cta = container.querySelector('.bsw-v5-cta');
      var show = !!cta && cta.getBoundingClientRect().bottom < 0;
      var mobile = isMobile();

      /* Mirror the CTA label, so the sticky button names the same thing
         (Einmalkauf with price, "WIRD HINZUGEFÜGT…" while adding). */
      var label = cta ? cta.textContent : config.ctaText;
      if (barBtn.textContent !== label) barBtn.textContent = label;
      if (headerBtn && headerBtn.textContent !== label) headerBtn.textContent = label;

      if (headerBtn) headerBtn.classList.toggle('is-visible', show && !mobile);
      bar.classList.toggle('is-visible', show && mobile);

      /* Sit directly under the mobile header, wherever it currently ends */
      if (mobile) {
        var header = document.querySelector('.header__mobile');
        var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
        bar.style.top = top + 'px';
      }
    };

    /* The theme slides its sticky header in after scrolling stops, so
       measure once more when that animation is done. */
    var settleTimer = null;
    var check = stickyCheck;
    stickyCheck = function () {
      check();
      clearTimeout(settleTimer);
      settleTimer = setTimeout(check, 400);
    };

    window.addEventListener('scroll', stickyCheck, { passive: true });
    window.addEventListener('resize', stickyCheck);
    /* Re-renders change the CTA label without any scrolling */
    stickyObserver = new MutationObserver(stickyCheck);
    stickyObserver.observe(container, { childList: true, subtree: true, characterData: true });
    stickyCheck();
  }

  /* ------------------------------------------------------------------
     HTML BUILDERS
  ------------------------------------------------------------------ */
  function savingsLabel(plan, config, oneTime) {
    var pct = oneTime ? plan.onetimeDiscount : plan.discount;
    var eur = oneTime ? plan.onetimeDiscountEur : plan.discountEur;
    if (!pct) return '';
    return config.savingsFormat === 'euro'
      ? 'Spare ' + eur + ' €'
      : 'Spare ' + pct + '%';
  }

  /* Einmalkauf block, shown in the selected row instead of the Abo
     details. The last line is the gap to the Abo price of the same size,
     so it always matches the prices on screen. */
  function onetimeDetails(p, uspIcon) {
    var items = ['Eine Lieferung, kein Abo', 'Keine Mindestlaufzeit, nichts zu kündigen'];
    var gapCents = p.regularPriceCents - p.subPriceCents;
    if (gapCents > 0) items.push('Im Abo zahlst du ' + formatEurRounded(gapCents) + ' weniger');
    return (
      '<div class="bsw-v5-row-details">' +
        '<div class="bsw-v5-option-title">Einmalkauf' +
          ' <span class="bsw-v5-option-frequency"><span class="bsw-v5-dot">· </span>Einmalige Lieferung</span>' +
        '</div>' +
        '<ul class="bsw-v5-usps">' +
          items.map(function (u) {
            return '<li class="bsw-v5-usp-item">' + uspIcon + '<span>' + nbspUnits(escHtml(u)) + '</span></li>';
          }).join('') +
        '</ul>' +
      '</div>'
    );
  }

  function buildHTML(plans, state, config) {
    var selected = plans.find(function (p) { return p.id === state.selectedId; }) || plans[0];

    /* Section label */
    var sizeLabel = config.sizeLabel
      ? '<div class="bsw-v5-size-label">' + escHtml(config.sizeLabel) + '</div>'
      : '';

    var uspIcon = config.uspIcon
      ? '<span aria-hidden="true">' + escHtml(config.uspIcon) + '</span> '
      : '';

    /* One full-width row per variant. Every row carries the pricing the V4
       Abo box showed for the selected plan (old price, price, savings), so
       she can compare all three without clicking. The selected row opens
       to show the Abo name, delivery rhythm and USPs. */
    var rows =
      '<div class="bsw-v5-stack" role="radiogroup">' +
        plans.map(function (p) {
          var isSel = p.id === state.selectedId;
          var priceCents = state.oneTime ? p.regularPriceCents : p.subPriceCents;
          var hasCompare = p.comparePriceCents > priceCents;
          var savings = config.showCardSavings ? savingsLabel(p, config, state.oneTime) : '';

          var labelBadge = p.badge
            ? '<span class="bsw-v5-row-badge">' + escHtml(p.badge) + '</span>'
            : '';

          var imgHtml = p.imageUrl
            ? '<img class="bsw-v5-row-img" src="' + escHtml(p.imageUrl) + '" alt="' + escHtml(p.label) + '">'
            : '<div class="bsw-v5-row-img bsw-v5-row-img--placeholder">' + p.months + '×</div>';

          var perDay = config.showPerDay
            ? '<div class="bsw-v5-row-perday">' + escHtml(state.oneTime ? p.onetimePerDay : p.perDay) + '</div>'
            : '';

          var details = '';
          if (isSel && state.oneTime) {
            details = onetimeDetails(p, uspIcon);
          } else if (isSel) {
            var frequency = config.frequencyPrefix + ' ' +
              (p.months === 1 ? 'Monat' : p.months + '. Monat');
            details =
              '<div class="bsw-v5-row-details">' +
                '<div class="bsw-v5-option-title">' + escHtml(config.aboLabel) +
                  '<button class="bsw-v5-info-btn" type="button" aria-label="Mehr erfahren"><span aria-hidden="true">?</span></button>' +
                  ' <span class="bsw-v5-option-frequency"><span class="bsw-v5-dot">· </span>' + escHtml(frequency) + '</span>' +
                '</div>' +
                '<ul class="bsw-v5-usps">' +
                  p.usps.filter(function (u) { return u && u.length; }).map(function (u) {
                    return '<li class="bsw-v5-usp-item">' + uspIcon + '<span>' + escHtml(u) + '</span></li>';
                  }).join('') +
                '</ul>' +
              '</div>';
          }

          return (
            '<div class="bsw-v5-row' + (isSel ? ' bsw-v5-row--selected' : '') + (p.badge ? ' bsw-v5-row--badged' : '') + '" ' +
              'data-variant-id="' + escHtml(p.id) + '" ' +
              'role="radio" tabindex="0" aria-checked="' + (isSel ? 'true' : 'false') + '">' +
              labelBadge +
              '<div class="bsw-v5-row-main">' +
                imgHtml +
                '<div class="bsw-v5-row-info">' +
                  '<div class="bsw-v5-row-name">' + escHtml(p.label) + '</div>' +
                  perDay +
                '</div>' +
                '<div class="bsw-v5-row-prices">' +
                  '<div class="bsw-v5-row-price-line">' +
                    (hasCompare ? '<span class="bsw-v5-option-old-price">' + formatEurRounded(p.comparePriceCents) + '</span>' : '') +
                    '<span class="bsw-v5-option-price">' + formatEurRounded(priceCents) + '</span>' +
                  '</div>' +
                  (savings ? '<span class="bsw-v5-option-savings">' + savings + '</span>' : '') +
                '</div>' +
              '</div>' +
              details +
            '</div>'
          );
        }).join('') +
      '</div>';

    /* CTA. The Einmalkauf button always carries its price, so the
       one-time path never looks cheaper than it is. The Abo button
       shows its price only if the merchant turns it on. */
    var ctaLabel;
    if (state.oneTime) {
      ctaLabel = config.ctaOnetimeText + ' · ' + formatEurRounded(selected.regularPriceCents);
    } else {
      ctaLabel = config.ctaText;
      if (config.ctaShowPrice) {
        ctaLabel += ' · ' + formatEurRounded(selected.subPriceCents);
      }
    }
    var cta = '<button type="button" class="bsw-v5-cta">' + escHtml(ctaLabel) + '</button>';

    /* Proof line, directly above the CTA in V5. No element at all when
       it is off, so there is no empty node and no leftover margin. */
    var proof = '';
    if (config.showProof && config.proofText) {
      proof = '<span class="bsw-v5-proof">' + nbspUnits(escHtml(config.proofText)) + '</span>';
    }

    /* Trust checkmarks, between the proof line and the CTA */
    var trust = '';
    var trustItems = config.showTrust ? config.trust.filter(function (t) { return t.length; }) : [];
    if (trustItems.length) {
      trust = '<ul class="bsw-v5-trust">' + trustItems.map(function (t) {
        return '<li class="bsw-v5-trust-item">' +
          '<svg class="bsw-v5-check" viewBox="0 0 20 20" aria-hidden="true">' +
            '<circle cx="10" cy="10" r="10" fill="currentColor"/>' +
            '<path d="M5.8 10.4l2.7 2.7 5.7-5.9" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg><span>' + nbspUnits(escHtml(t)) + '</span></li>';
      }).join('') + '</ul>';
    }

    /* Einmalkauf link */
    var onetime = '';
    if (config.showOnetime) {
      var linkLabel = state.oneTime ? config.backToSubLabel : config.onetimeLabel;
      var linkPrice = state.oneTime ? selected.subPriceCents : selected.regularPriceCents;
      onetime =
        '<div class="bsw-v5-onetime">' +
          '<button type="button" class="bsw-v5-onetime-link" aria-pressed="' + (state.oneTime ? 'true' : 'false') + '">' +
            escHtml(linkLabel) + ' · ' + formatEurRounded(linkPrice) +
          '</button>' +
        '</div>';
    }

    return sizeLabel + rows + proof + trust + cta + onetime;
  }

  /* ------------------------------------------------------------------
     MODAL
  ------------------------------------------------------------------ */
  function setupModal(config) {
    var modal = document.getElementById(MODAL_ID);
    if (!modal || modal.dataset.bswBound === 'true') return;
    modal.dataset.bswBound = 'true';

    var backdrop = document.getElementById('bsw-v5-modal-backdrop');
    var closeBtn = document.getElementById('bsw-v5-modal-close');
    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    modal.addEventListener('click', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('bsw-v5-modal-dismiss')) closeModal();
    });
  }

  function updateModalContent(config, state) {
    var body = document.getElementById('bsw-v5-modal-body');
    if (!body) return;
    body.innerHTML = buildModalContent(config, state);
  }

  function openModal() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('bsw-v5-modal--open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('bsw-v5-modal--open');
    document.body.style.overflow = '';
  }

  function buildModalContent(config, state) {
    var modalUsps = config.modal.usps.slice(0);
    if (state && state.selectedId === '1m' && config.modal.usp3_1m) {
      modalUsps[2] = {
        title: config.modal.usp3_1m.title,
        body:  config.modal.usp3_1m.body,
        icon:  config.modal.usps[2].icon
      };
    }

    /* When the title ends with the Abo name ("Deine Vorteile im Happy Hair
       Club Abo"), the name goes on its own line and never splits, so the
       title always reads as two neat lines. Any other title renders as is. */
    var title = config.modal.title;
    var aboName = config.aboLabel;
    var titleHtml = escHtml(title);
    if (aboName && title.length > aboName.length && title.slice(-aboName.length) === aboName) {
      titleHtml = escHtml(title.slice(0, -aboName.length).trim()) +
        '<br><span class="bsw-v5-modal-title-name">' + escHtml(aboName) + '</span>';
    }
    var html = '<h2 id="bsw-v5-modal-title" class="bsw-v5-modal-title">' + titleHtml + '</h2>';
    html += '<ul class="bsw-v5-modal-usps">';
    modalUsps.forEach(function (usp) {
      if (!usp.title && !usp.body) return;
      html +=
        '<li class="bsw-v5-modal-usp">' +
          '<div class="bsw-v5-modal-usp-icon">' +
            '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">' + usp.icon + '</svg>' +
          '</div>' +
          '<div>' +
            '<strong class="bsw-v5-modal-usp-title">' + escHtml(usp.title) + '</strong>' +
            '<p class="bsw-v5-modal-usp-body">' + escHtml(usp.body) + '</p>' +
          '</div>' +
        '</li>';
    });
    html += '</ul>';

    /* Results after 3 months: study and customer survey side by side.
       Each figure renders only if both its number and its text are set. */
    var r = config.modal.results;
    if (r && r.show) {
      var stats = [[r.stat1, r.stat1Text], [r.stat2, r.stat2Text]].filter(function (st) {
        return st[0] && st[1];
      });
      if (r.title || r.intro || stats.length) {
        html += '<div class="bsw-v5-modal-results">';
        if (r.title) html += '<strong class="bsw-v5-modal-results-title">' + nbspUnits(escHtml(r.title)) + '</strong>';
        if (r.intro) html += '<p class="bsw-v5-modal-results-intro">' + nbspUnits(escHtml(r.intro)) + '</p>';
        if (stats.length) {
          html += '<div class="bsw-v5-modal-results-stats">' + stats.map(function (st) {
            return '<div class="bsw-v5-modal-results-stat">' +
              '<span class="bsw-v5-modal-results-value">' + nbspUnits(escHtml(st[0])) + '</span>' +
              '<span class="bsw-v5-modal-results-text">' + nbspUnits(escHtml(st[1])) + '</span>' +
            '</div>';
          }).join('') + '</div>';
        }
        html += '</div>';
      }
    }

    html += '<div class="bsw-v5-modal-footer">' +
      '<button class="bsw-v5-modal-dismiss" type="button">' + escHtml(config.modal.dismiss) + '</button>' +
    '</div>';
    return html;
  }

  /* ------------------------------------------------------------------
     START
  ------------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWidget);
  } else {
    initWidget();
  }

  /* Re-init when the theme editor re-renders the section */
  document.addEventListener('shopify:section:load', initWidget);

})();
